(() => {
  const TIMEOUT_MS = 12000;

  const bindSignup = (root) => {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    const form = root.querySelector('[data-newsletter-form]');
    const submitBtn = root.querySelector('[data-newsletter-submit]');
    const errorEl = root.querySelector('[data-newsletter-error]');
    const successEl = root.querySelector('[data-newsletter-success]');
    if (!form || !submitBtn) return;

    const companyId = root.dataset.companyId;
    const listId = root.dataset.listId;
    if (!companyId || !listId) return;

    const submittingLabel = root.dataset.submittingLabel || '…';
    const errorGeneric = root.dataset.errorGeneric || 'Bitte versuchen Sie es erneut.';
    const defaultLabel = submitBtn.textContent;

    const showError = (message) => {
      root.classList.add('is-error');
      root.classList.remove('is-success');
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = message;
      }
      if (successEl) successEl.hidden = true;
    };

    const showSuccess = () => {
      root.classList.add('is-success');
      root.classList.remove('is-error');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (successEl) successEl.hidden = false;
      form.hidden = true;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const emailInput = form.querySelector('input[type="email"]');
      const email = (emailInput?.value || '').trim();
      if (!email) {
        showError(errorGeneric);
        return;
      }

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Casa Azul Newsletter Footer',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  locale: 'de-DE',
                  properties: {
                    newsletter_source: 'footer',
                  },
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId,
              },
            },
          },
        },
      };

      submitBtn.disabled = true;
      submitBtn.textContent = submittingLabel;

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_MS);

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              revision: '2025-01-15',
            },
            body: JSON.stringify(payload),
            signal: controller.signal,
            mode: 'cors',
            credentials: 'omit',
          }
        );

        clearTimeout(timeoutId);

        if (!(response.ok || response.status === 202)) {
          let detail = errorGeneric;
          try {
            const errJson = await response.json();
            const first = errJson?.errors?.[0];
            if (first?.detail) detail = first.detail;
          } catch (_) {
            /* ignore */
          }
          throw new Error(detail);
        }

        showSuccess();
      } catch (_) {
        clearTimeout(timeoutId);
        showError(errorGeneric);
        submitBtn.disabled = false;
        submitBtn.textContent = defaultLabel;
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-newsletter-klaviyo]').forEach(bindSignup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
